import { FC } from 'react';

interface IconProps {
  color?: string;
  width?: number;
  height?: number;
}

export const CalendarIcon: FC<IconProps> = ({ color = '#807D93', width = 15, height = 15 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 15 15"
    fill="none"
  >
    <path
      d="M10.625 1.25C10.2812 1.25 10 1.53125 10 1.875V2.5H5V1.875C5 1.53125 4.71875 1.25 4.375 1.25C4.03125 1.25 3.75 1.53125 3.75 1.875V2.5H3.125C2.43125 2.5 1.88125 3.0625 1.88125 3.75L1.875 12.5C1.875 13.1875 2.43125 13.75 3.125 13.75H11.875C12.5625 13.75 13.125 13.1875 13.125 12.5V3.75C13.125 3.0625 12.5625 2.5 11.875 2.5H11.25V1.875C11.25 1.53125 10.9688 1.25 10.625 1.25ZM11.875 12.5H3.125V6.25H11.875V12.5ZM6.875 8.125C6.875 7.78125 7.15625 7.5 7.5 7.5C7.84375 7.5 8.125 7.78125 8.125 8.125C8.125 8.46875 7.84375 8.75 7.5 8.75C7.15625 8.75 6.875 8.46875 6.875 8.125ZM4.375 8.125C4.375 7.78125 4.65625 7.5 5 7.5C5.34375 7.5 5.625 7.78125 5.625 8.125C5.625 8.46875 5.34375 8.75 5 8.75C4.65625 8.75 4.375 8.46875 4.375 8.125ZM9.375 8.125C9.375 7.78125 9.65625 7.5 10 7.5C10.3438 7.5 10.625 7.78125 10.625 8.125C10.625 8.46875 10.3438 8.75 10 8.75C9.65625 8.75 9.375 8.46875 9.375 8.125ZM6.875 10.625C6.875 10.2812 7.15625 10 7.5 10C7.84375 10 8.125 10.2812 8.125 10.625C8.125 10.9688 7.84375 11.25 7.5 11.25C7.15625 11.25 6.875 10.9688 6.875 10.625ZM4.375 10.625C4.375 10.2812 4.65625 10 5 10C5.34375 10 5.625 10.2812 5.625 10.625C5.625 10.9688 5.34375 11.25 5 11.25C4.65625 11.25 4.375 10.9688 4.375 10.625ZM9.375 10.625C9.375 10.2812 9.65625 10 10 10C10.3438 10 10.625 10.2812 10.625 10.625C10.625 10.9688 10.3438 11.25 10 11.25C9.65625 11.25 9.375 10.9688 9.375 10.625Z"
      fill={color}
    />
  </svg>
);

export const SectionChevronIcon: FC<IconProps> = ({ color = '#807D93', width = 9, height = 6 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 9 6"
    fill="none"
  >
    <path
      d="M7.49193 4.98328L4.42026 1.91161L1.34859 4.98328C1.03984 5.29203 0.541093 5.29203 0.232343 4.98328C-0.0764074 4.67453 -0.0764073 4.17578 0.232343 3.86703L3.86609 0.233281C4.17484 -0.0754694 4.67359 -0.0754694 4.98234 0.233281L8.61609 3.86703C8.92484 4.17578 8.92484 4.67453 8.61609 4.98328C8.30734 5.28411 7.80068 5.29203 7.49193 4.98328Z"
      fill={color}
    />
  </svg>
);

export const ExclamationIcon: FC<IconProps> = ({ color = '#807D93', width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.54702 7.9997C2.54714 11.0121 4.98922 13.4543 8.00166 13.4543C11.014 13.4542 13.4562 11.012 13.4563 7.9997C13.4563 4.98727 11.0141 2.54519 8.00166 2.54506C4.98914 2.54506 2.54702 4.98719 2.54702 7.9997ZM1.33464 7.9997C1.33464 4.31774 4.31969 1.33268 8.00166 1.33268C11.6835 1.33281 14.668 4.31782 14.668 7.9997C14.6678 11.6815 11.6834 14.6659 8.00166 14.666C4.31977 14.666 1.33476 11.6816 1.33464 7.9997Z"
      fill={color}
    />
    <path
      d="M8.60726 5.57542L8.60726 7.99947C8.60726 8.33419 8.33615 8.6053 8.00142 8.6053C7.6667 8.6053 7.39559 8.33419 7.39559 7.99947L7.39559 5.57542C7.39559 5.24069 7.6667 4.96887 8.00142 4.96887C8.33615 4.96887 8.60726 5.24069 8.60726 5.57542Z"
      fill={color}
    />
    <path
      d="M7.99503 11.0296C7.66046 11.0294 7.38919 10.7584 7.38919 10.4238C7.38919 10.0891 7.66046 9.8181 7.99503 9.81792L8.00142 9.81792C8.33615 9.81792 8.60726 10.089 8.60726 10.4238C8.60726 10.7585 8.33615 11.0296 8.00142 11.0296L7.99503 11.0296Z"
      fill={color}
    />
  </svg>
);

export const ClockIcon: FC<IconProps> = ({ color = '#807D93', width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M13.6016 8C13.6016 4.96243 11.1391 2.5 8.10156 2.5C5.064 2.5 2.60156 4.96243 2.60156 8C2.60156 11.0376 5.064 13.5 8.10156 13.5C11.1391 13.5 13.6016 11.0376 13.6016 8ZM7.60156 5.61393C7.60156 5.33779 7.82542 5.11393 8.10156 5.11393C8.3777 5.11393 8.60156 5.33779 8.60156 5.61393V8.38932L10.5098 9.02539C10.7717 9.11271 10.9135 9.39623 10.8262 9.6582C10.7388 9.92017 10.4553 10.0619 10.1934 9.97461L7.94336 9.22461C7.73919 9.15655 7.60156 8.96522 7.60156 8.75V5.61393ZM14.6016 8C14.6016 11.5899 11.6914 14.5 8.10156 14.5C4.51171 14.5 1.60156 11.5899 1.60156 8C1.60156 4.41015 4.51171 1.5 8.10156 1.5C11.6914 1.5 14.6016 4.41015 14.6016 8Z"
      fill={color}
    />
  </svg>
);

export const BellIcon: FC<IconProps> = ({ color = '#807D93', width = 16, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M9.46674 13.0033C9.68249 12.8309 9.99751 12.8663 10.1699 13.082C10.342 13.2978 10.3067 13.6122 10.0911 13.7845C9.52947 14.2332 8.79607 14.5 8.00124 14.5C7.20642 14.5 6.47302 14.2332 5.9114 13.7845C5.69574 13.6122 5.66045 13.2978 5.83262 13.082C6.00498 12.8663 6.32 12.8309 6.53575 13.0033C6.91768 13.3083 7.43016 13.5 8.00124 13.5C8.57232 13.5 9.0848 13.3083 9.46674 13.0033ZM8.00124 1.5C10.8254 1.5 13.0384 3.99466 13.0384 6.97331V6.97917L13.0221 8.36393C13.0235 9.25169 13.347 9.99421 13.6848 10.5026C13.8785 10.7941 13.8606 11.1417 13.7643 11.39C13.6708 11.6307 13.4235 11.9544 12.9967 11.9544H3.00645C2.57285 11.9544 2.32614 11.6215 2.23496 11.3796C2.1407 11.1293 2.12479 10.7756 2.32741 10.4831L2.45827 10.2813C2.7586 9.78676 3.01359 9.12624 3.01361 8.35807V8.35221L3.02989 6.89583C3.0325 3.95939 5.21511 1.5 8.00124 1.5ZM8.00124 2.5C5.85013 2.5 4.02992 4.42624 4.02989 6.90104V6.9069L4.01361 8.36328C4.01235 9.43709 3.6245 10.3293 3.21283 10.9544H12.7884C12.3935 10.3279 12.0221 9.43336 12.0221 8.35807V8.35221L12.0384 6.97331L12.0331 6.73893C11.9224 4.33795 10.1203 2.5 8.00124 2.5Z"
      fill={color}
    />
  </svg>
);

export const BellCheckIcon: FC<IconProps> = ({ color = '#504E5A', width = 63, height = 63 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 63 63"
    fill="none"
  >
    <path
      d="M33.6003 54.1995C34.1026 53.3336 35.2122 53.0378 36.0783 53.5397C36.9446 54.0422 37.2406 55.1539 36.7382 56.0201C36.1192 57.0871 35.2269 57.9702 34.1566 58.5853C33.0863 59.2004 31.8727 59.5258 30.6378 59.5276C29.4031 59.5292 28.1881 59.2073 27.1163 58.5953C26.0448 57.9832 25.1516 57.1021 24.5299 56.0373C24.025 55.1725 24.3179 54.0599 25.1827 53.5551C26.0474 53.051 27.1579 53.3434 27.6626 54.2079C27.9624 54.7213 28.394 55.1501 28.9156 55.448C29.437 55.7455 30.0293 55.9019 30.6327 55.9012C31.2365 55.9004 31.8299 55.7425 32.3508 55.4431C32.8716 55.1438 33.302 54.7139 33.6003 54.1995ZM13.0566 21.355C13.0514 17.6729 14.223 14.0846 16.3994 11.1063C18.5754 8.12865 21.644 5.91302 25.1637 4.77616C28.6837 3.63939 32.4773 3.64003 35.9979 4.77508C39.5182 5.9102 42.5884 8.12276 44.7658 11.0994C45.357 11.9077 45.181 13.0421 44.3728 13.6333C43.5645 14.2243 42.4301 14.0484 41.8389 13.2402C40.1149 10.8834 37.6799 9.12745 34.8837 8.22595C32.0874 7.32461 29.074 7.32572 26.2782 8.22861C23.4829 9.13161 21.0503 10.8886 19.3276 13.2459C17.6048 15.6035 16.6789 18.441 16.683 21.3499C16.6914 27.3876 15.7432 31.5414 14.244 34.702C12.7581 37.8346 10.7861 39.8558 9.06212 41.6268C8.95849 41.7398 8.89098 41.8788 8.86673 42.026C8.84262 42.1735 8.86259 42.3274 8.92401 42.4651C8.98553 42.6026 9.08865 42.7201 9.2196 42.8047C9.35086 42.8893 9.50459 42.9363 9.66364 42.9362L51.5698 42.8773C51.7284 42.8769 51.8827 42.8314 52.0135 42.7468C52.1446 42.6619 52.2469 42.542 52.3081 42.404C52.3693 42.2664 52.3884 42.1145 52.3642 41.9672C52.34 41.8204 52.2732 41.6813 52.17 41.5685C50.7967 40.1661 49.2446 38.5854 47.9226 36.4229C47.4011 35.569 47.6701 34.4537 48.5235 33.9313C49.3779 33.409 50.4951 33.6778 51.0175 34.5322C52.1071 36.3145 53.3917 37.6347 54.7919 39.0646L54.7989 39.0716L54.8368 39.1117C55.417 39.7427 55.8028 40.5301 55.9425 41.3767C56.0821 42.2229 55.9704 43.0913 55.6226 43.875C55.2745 44.6588 54.7034 45.3238 53.9844 45.7896C53.356 46.1965 52.6366 46.4369 51.8937 46.4914L51.5726 46.5036L9.66638 46.5626C8.81061 46.5632 7.97204 46.3173 7.25253 45.853C6.53271 45.3884 5.96073 44.724 5.61136 43.9406C5.26228 43.1575 5.15096 42.2896 5.28912 41.4432C5.42746 40.5969 5.80974 39.8092 6.38848 39.1775L6.4262 39.1374C8.16353 37.3525 9.7555 35.7027 10.9673 33.1484C12.1767 30.5987 13.0645 27.0094 13.0566 21.355ZM52.8714 14.8136C53.5812 14.1077 54.7291 14.1097 55.4353 14.8194C56.1413 15.5289 56.1384 16.6769 55.4295 17.3834L44.9664 27.7956C44.2605 28.4973 43.1196 28.4992 42.4119 27.7992L37.1681 22.6078C36.4564 21.9036 36.4488 20.7557 37.1526 20.0439C37.857 19.3321 39.0048 19.3266 39.7166 20.0308L43.6814 23.9538L52.8714 14.8136Z"
      fill={color}
    />
  </svg>
);

export const AuditHeaderIcon: FC<IconProps> = ({ color = '#807D93', width = 19, height = 19 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 19 19"
    fill="none"
  >
    <path
      d="M3.02238 10.0017C3.02254 13.579 5.9225 16.4791 9.49977 16.4791C13.0769 16.479 15.977 13.5789 15.9772 10.0017C15.9772 6.42445 13.077 3.52449 9.49977 3.52433C5.92241 3.52433 3.02238 6.42436 3.02238 10.0017ZM1.58268 10.0017C1.58268 5.62939 5.12744 2.08463 9.49977 2.08463C13.872 2.08479 17.416 5.62948 17.416 10.0017C17.4159 14.3738 13.8719 17.9178 9.49977 17.918C5.12753 17.918 1.58283 14.3739 1.58268 10.0017Z"
      fill={color}
    />
    <path
      d="M10.2189 7.12288L10.2189 10.0014C10.2189 10.3989 9.89698 10.7209 9.49949 10.7209C9.10201 10.7209 8.78006 10.3989 8.78006 10.0014L8.78006 7.12288C8.78006 6.7254 9.10201 6.40261 9.49949 6.40261C9.89698 6.40261 10.2189 6.7254 10.2189 7.12288Z"
      fill={color}
    />
    <path
      d="M9.4919 13.5997C9.0946 13.5995 8.77247 13.2776 8.77247 12.8803C8.77247 12.4829 9.0946 12.1611 9.4919 12.1609L9.49949 12.1609C9.89698 12.1609 10.2189 12.4828 10.2189 12.8803C10.2189 13.2778 9.89697 13.5997 9.49949 13.5997L9.4919 13.5997Z"
      fill={color}
    />
  </svg>
);
